import React, { useEffect, useRef } from 'react';
import { useUserProfile } from '../../helper/UserProfile';
import { Link, useLocation } from "react-router-dom";

const MobileRevalNav = () => {
    const { profile } = useUserProfile();

    const location = useLocation();
    const activeRef = useRef(null);

      useEffect(() => {
        if (activeRef.current) {
        activeRef.current.scrollIntoView({
            inline: "center",
            block: "nearest"         
        });
        }
    }, [location.pathname]);    

  return (
    <div className="mob-flex-plus">
            <Link to="/dashboard/revalidation" className={location.pathname === "/dashboard/revalidation" ? "mob-option-button active" : "mob-option-button"} ref={location.pathname === "/dashboard/revalidation" ? activeRef : null} style={{marginLeft: "10px"}}>
                Dashboard
            </Link>

            <Link to="/dashboard/revalidationDocuments" className={location.pathname === "/dashboard/revalidationDocuments" ? "mob-option-button active" : "mob-option-button"} ref={location.pathname === "/dashboard/revalidationDocuments" ? activeRef : null}>
                Documents
            </Link>

            <Link to="/dashboard/revalidationCpd" className={location.pathname === "/dashboard/revalidationCpd" ? "mob-option-button active" : "mob-option-button"} ref={location.pathname === "/dashboard/revalidationCpd" ? activeRef : null}>
                CPD
            </Link>

            <Link to="/dashboard/revalidationPhl" className={location.pathname === "/dashboard/revalidationPhl" ? "mob-option-button active" : "mob-option-button"} ref={location.pathname === "/dashboard/revalidationPhl" ? activeRef : null}>
                PHL
            </Link>

            <Link to="/dashboard/revalidationReflectiveAccount" className={location.pathname === "/dashboard/revalidationReflectiveAccount" ? "mob-option-button xl active" : "mob-option-button xl"} ref={location.pathname === "/dashboard/revalidationReflectiveAccount" ? activeRef : null}>
                Reflective Account
            </Link>

            <Link to="/dashboard/revalidationFeedback" className={location.pathname === "/dashboard/revalidationFeedback" ? "mob-option-button active" : "mob-option-button"} ref={location.pathname === "/dashboard/revalidationFeedback" ? activeRef : null}>
                Feedback
            </Link>

            <Link to="/dashboard/revalidationConfirmation" className={profile.reval_members.membership_tier === "Gold" ? "hide" : location.pathname === "/dashboard/revalidationConfirmation" ? "mob-option-button active" : "mob-option-button"} ref={location.pathname === "/dashboard/revalidationConfirmation" ? activeRef : null} style={{marginRight: "10px"}}>
                Confirmation
            </Link>
        </div> 
  )
}

export default MobileRevalNav